import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import Home from "./pages/home";
import Contact from "./pages/contact";
import Project from "./pages/project";
import Features from './pages/features';
import Error from "./pages/404";

import "./styles/custom.css";
function App() {
  return (
    <Router>
      <Switch>
        <Home exact path="/" />
        <Contact exact path="/about" />
        <Project exact path="/product" />
        <Features exact path="/features" />
        <Error path="/" />
      </Switch>
    </Router>
  );
}

export default App;
